import { makeStyles } from "@material-ui/core"

import { FlowStatusConfig } from "@/pages/Admin/Flow/FlowList/FlowListItem/FlowListItemDetails"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	listItemData: {
		opacity: "0.5",
		fontSize: "14px"
	},
	clockIcon: {
		width: "16px",
		height: "16px",
		color: colors.gray[700],
		opacity: "0.5",
		marginRight: "10px"
	},
	chip: {
		color: colors.gray[700],
		fontSize: 14,
		padding: "4px 16px",
		backgroundColor: (props: FlowStatusConfig) => props.chipBackgroundColor
	}
}))

export default useStyles
